export default {
  en: {
    btnSave: 'Save & Leave',
    btnLeave: 'Leave',
    header: 'The form data is not saved',
    subHeader: 'Do you really want to leave?',
  },
};
